import { render, staticRenderFns } from "./responsibilities.vue?vue&type=template&id=51a7f6c6&scoped=true&"
import script from "./responsibilities.vue?vue&type=script&lang=js&"
export * from "./responsibilities.vue?vue&type=script&lang=js&"
import style0 from "./responsibilities.vue?vue&type=style&index=0&id=51a7f6c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a7f6c6",
  null
  
)

export default component.exports